<template>
	<div class="container">
		<div class="row mt-2">
			<div class="col-12">
				<h1 class="text-white">Congratulations!</h1>
				<p class="text-white"> You've completed <b> {{ className }}</b> class. Click <a :href="link" target="_blank" class="text-primary">here</a> to download your certificate of completion! </p>
			</div>
		</div>
		<hr>
	</div>
</template>

<script>
    export default {
        name: 'Complete',
        props:[ 'link', 'className' ],
        components: {
        },
        data: function(){
            return {
            }
        },
        mounted: function(){
        }
    }
</script>
